import { t } from 'i18next';
import { useCallback } from 'react'
import { Button } from 'devextreme-react/button';
import { orderService } from '../services/order-service';
import { toast } from 'react-toastify';
import { Height } from 'devextreme-react/cjs/chart';
const OrderSetting = () => {
    const onQuery = useCallback(async () => {await orderService.getOrdersDelete().then(x=>  toast.success( t("syncflow:msg_saved")))  }, []);
    return (
        <div className='row mb-4 justify-content-end'>
        <div className='col-auto'>
            <Button
                text={t("syncflow:btn_clear_orders")}
                type="default"
                icon="clear" 
                onClick={onQuery}
            />
        </div>
        <div style={{height:'800px'}}></div>
    </div>
    )
}
export default OrderSetting